export default {"src":"/_next/static/media/medal.bb0ac100.svg","height":84,"width":73};